import React from 'react';
import './sale.styless.scss';

import uuid from 'react-uuid';
import { numberWithCommas } from '../../util-functions/numer-formating';
import { dateFormat } from '../../util-functions/date-format';
import { withRouter } from 'react-router-dom';
import { updateSale } from '../../Redux/sale/sale.actions';
import { createStructuredSelector} from 'reselect';
import { connect } from 'react-redux';
import { selectSaleSales } from '../../Redux/sale/sale.selectors';
import ItemsDropDown from '../items-dropdown/items-dropdown.component';

class SaleFlattened extends React.Component{
    state={
        showDropDown: {status: false},
        status: '',
    }

    handleUpdateStatus = (item, name, key) => {
        const {updateSale} = this.props;
        console.log(item[key])
        let { sale, sales } = this.props;
        let returnedSale = sales.find(s => s.id === sale.id);
        returnedSale = {...returnedSale, date: new Date(returnedSale.date), status: item[key]}
        this.setState({...this.state, showDropDown: {status: false}});
        updateSale(returnedSale, 'status');
    }

    handleReport = (sale) => {
        const {history} = this.props;
        history.push(`/sale-report/${sale.id}`)
    }

    toggleDropDown = (name) => {
        this.setState({
            ...this.state,
            showDropDown: {
                         [name]:!this.state.showDropDown[name]
                        }
        })
    }

    render(){
        let {fieldToDisplay} = this.props;
        const {sale, i, isFirstLine, isLastLine, handleClick} = this.props;
        //sale['order'] to see whether it is the first REN in the sale and display accordingly
        //Hide for Mobile View
        const isHidden = (key) =>{
            switch(key){
            case 'saleId':
                return true
            case 'date':
                return true
            case 'projectName':
                return true
            case 'unitNumber':
                return true
            case 'netPrice':
                return true
            case 'buyerName':
                return true
            default:
                return false
        }}

        return(
            <React.Fragment>
            {!i &&
            <div className='sc-row-header'>
                {Object.keys(fieldToDisplay).map((key,i) => {
                    return(
                        <div key={uuid()} className={`sc-header sc-${key}`}>{fieldToDisplay[key]}</div>
                    )
                })}
            </div>
            }
            <div className={!isFirstLine ? 'sc-row' : 'sc-row-border'} >
            {Object.keys(fieldToDisplay).map((key,i) => {
                let hideOrShow = '';
                if(!isFirstLine && isHidden(key)){hideOrShow = '-hidden'}
                if(!isLastLine && key==='status'){hideOrShow = '-hidden'}
                return(
                    <div key={uuid()} className={`sc-${key}${hideOrShow}`} >
                    {(()=>{
                        switch(key){
                            case 'netPrice':
                                return <React.Fragment>{!sale['order'] ? numberWithCommas(sale[key]) : null}</React.Fragment>
                            case 'saleId':
                                return <div className='sc-saleId-Item' onClick={()=>{handleClick(sale)}}>{!sale['order'] ? sale[key] : null}</div>
                            case 'remark':
                                return <React.Fragment>{!sale['order'] ? sale[key] : null}</React.Fragment>
                            case 'date':
                                return <React.Fragment>{!sale['order'] ? dateFormat(sale[key]) : null}</React.Fragment>
                            case 'projectName':
                                return <React.Fragment>{!sale['order'] ? sale[key] : null}</React.Fragment>
                            case 'unitNumber':
                                return <React.Fragment>{!sale['order'] ? sale[key] : null}</React.Fragment>
                            case 'buyerName':
                                return <React.Fragment>{!sale['order'] ? sale[key] : null}</React.Fragment>
                            case 'commForRen':
                            case 'netPriceForRen':
                            case 'totalSales':
                            case 'totalComm':
                                return <React.Fragment>{numberWithCommas(sale[key])}</React.Fragment>
                            case 'status':
                                return <React.Fragment>
                                            <div className='sc-report' onClick={()=>this.handleReport(sale)}>Report</div>
                                            <div className='sc-update' onClick={()=>handleClick(sale)}>Update</div>
                                            <div className={`sc-status-${sale[key]} sc-status-item`} onClick={()=>{this.toggleDropDown('status')}}>{(sale[key])}</div>
                                            {this.state.showDropDown['status'] ?
                                            <ItemsDropDown
                                                            name='status'
                                                            type='text'
                                                            items = {[{status: 'Booked'}, {status: 'Converted'}, {status: 'Cancelled'}]} //Items to pass in
                                                            keyToMap = 'status' //List out the values corresposing to the key
                                                            clickItem = {this.handleUpdateStatus} //list state up function
                                                            toggleDropDown = {this.toggleDropDown}
                                                        /> : null
                                            }
                                        </React.Fragment>  
                            default:
                                return <React.Fragment>{sale[key]}</React.Fragment>
                        }
                    })()}
                    </div>
                )
            })}
            </div>
            </React.Fragment>
        )
    }
}

const mapStatesToProps = createStructuredSelector({
    sales: selectSaleSales,
});
  
const mapDispatchToProps = dispatch => ({
   updateSale: (sale, additionalOptions)=>dispatch(updateSale(sale, additionalOptions)),

});

export default withRouter(connect(mapStatesToProps, mapDispatchToProps)(SaleFlattened));

